<template>
  <div
    id="app"
    style="min-height: 100%"
  >
    <v-app
      id="ukpl"
      class="cppsbg"
    >
      <v-container
        fluid
        class="pa-0"
      >
        <router-view />
      </v-container>
    </v-app>
  </div>
</template>

<script>
export default {
  name: "App",

  data: () => ({}),
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logOut() {
      console.log("logging out");
      this.$store.dispatch("auth/logout");
      this.$router.push("/home");
    },
  },
};
</script>

<style>
/* See assets main.css */
</style>
